goog.provide('el8.appchart.dialog.viewInlineCda');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.dialog.reconcileCdaImport');
goog.require('el8.appchart.dialog.reconcileCdaImportDemographics');
goog.require('el8.appchart.mainFeeds.chartFileUploader');
goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.template.appchart.dialog.viewInlineCda');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.amplitude.ccdaImportHelpers');


/**
 * This dialog renders an xmlPatientSummary, which wraps a C-CDA/CCD/etc.
 * in a dialog on the current page. It is similar to viewInlinePdf
 */
el8.appchart.dialog.viewInlineCda = (function() {

    var patientId = null;
    var summaryId = null;

    var UNPROCCESSABLE_MSG = 'Sorry, we are not yet able to automatically import data from this type of document.';

    var that = new el8.uiwidget.NewDialog({
        width: 570,
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight();
        },
        position: 'center',
        showXButton: true
    });
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'sign-import', 'Sign Off & Import All', function() { signFn(true); }, true
    );
    buttonSet.addButton(
        'sign-import-qrda', 'Sign Off & Import QRDA', function() { signFn(true); }, true
    );
    buttonSet.addButton(
        'sign', 'Sign Off', function() { signFn(false); }, false
    );
    buttonSet.addButton(
        'open-tab', 'View in New Tab', function() {
            window.open(el8.service.urls.get('fullscreenXml', [patientId, summaryId]));
        }, false
    );

    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.import-all-trigger',  function() {
            var $buttons = $('.import-button-section button', that.getContentElt());
            $buttons.prop('disabled', true);
            el8.util.amplitude.logCcdaImportSection('all');
            el8.appservice.notifier.notify('Importing data from patient summary...');

            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('importXmlSummary', [patientId, summaryId]),
                success: function(data) {
                    $buttons.prop('disabled', false);
                    // create xml summary in front end and rerender list
                    el8.ptdata.xmlSummaries.create(data.xml_summary);
                    renderImportedList();
                    el8.appchart.mainFeeds.chartFileUploader.refreshChangedSections(data.changed_sections);
                    el8.appservice.notifier.notify('Data from patient summary imported.');
                    el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();
                },
                error: function(data) {
                    $buttons.prop('disabled', false);
                    if (data.status === 422) {
                        el8.uiwidget.alert(UNPROCCESSABLE_MSG);
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                }
            });

        }).on('click', '.import-reconcile-section-trigger',  function() {
            var sectionName = $(this).data('section').toLowerCase();
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('stageImportXmlSummary', [patientId, summaryId, sectionName]),
                success: function(data) {
                    if (!data) {
                        el8.uiwidget.alert('No new data to import from this section.');
                        return;
                    }

                    var dialogShowFn;
                    if (sectionName.startswith('demographics')) {
                        dialogShowFn = el8.appchart.dialog.reconcileCdaImportDemographics.show;
                    } else {
                        dialogShowFn = el8.appchart.dialog.reconcileCdaImport.show;
                    }
                    dialogShowFn({
                        sectionName: sectionName,
                        importJson: el8.util.keysFromUnderscoreToCamel(data),
                        summaryId: summaryId,
                        callbackFn: function(callback_data) {
                            // create xml summary in front end and rerender list
                            el8.ptdata.xmlSummaries.create(callback_data);
                            renderImportedList();
                            el8.appchart.mainFeeds.chartFileUploader.refreshChangedSections([sectionName]);
                        }
                    });
                },
                error: function(data) {
                    if (data.status === 422) {
                        el8.uiwidget.alert(UNPROCCESSABLE_MSG);
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                }
            });

        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        patientId = spec.patientId || el8Globals.PATIENT_ID;
        summaryId = spec.summaryId;

        var xmlSummary = el8.ptdata.fetch({ patientId: patientId, fetchId: summaryId});
        var soyMap = xmlSummary.asSoyMap();
        if (el8.data.currUser.isOfficeStaff()) {
            soyMap['physicianUsers'] = el8.data.practiceUsers.getPhysicianUsers();
        }

        that.setContent(el8.template.appchart.dialog.viewInlineCda.content(soyMap));

        if (xmlSummary.isSignedOff()) {
            buttonSet.hideButton('sign');
            buttonSet.hideButton('sign-import');
            buttonSet.hideButton('sign-import-qrda');
            if (xmlSummary.isQRDA_1()) {
                // for QRDA, we don't want them to open in new tab
                // because we are not displaying the coded values in the XSL
                buttonSet.hideButton('open-tab');
            }
            renderImportedList();
        } else {
            if (xmlSummary.isQRDA_1()) {
                // show specific button for QRDA
                buttonSet.hideButton('sign');
                buttonSet.hideButton('sign-import');
                buttonSet.hideButton('open-tab');
                buttonSet.showButton('sign-import-qrda');
            } else {
                buttonSet.hideButton('sign-import-qrda');
                buttonSet.showButton('sign');
                buttonSet.showButton('sign-import');
            }
        }

        renderXmlInSandbox();

        that.setTitle(spec.title || 'Patient Summary');
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.setContent(el8.template.appchart.dialog.viewInlineCda.content({})); // clear contents

        patientId = null;
        summaryId = null;
    };

    var super_adjustPosition = that.adjustPosition;
    that.adjustPosition = function() {
        super_adjustPosition.call(that);

        var $header = $('.dialog-header', that.getContentElt());
        var $footer = $('.select-physician-section', that.getContentElt());
        var iframeHeight = that.getContentElt().height() -
            ($header.outerHeight() || 0) -
            ($footer.outerHeight() || 0)  -
            5;
        $('iframe', that.getContentElt()).height(iframeHeight);
    };

    /* There are a lot of ways that we could render this XML and many of them leave us open
     * to exploits, since the XML is external / not trusted (server-side, it could explode
     * in RAM; client-side it could run JS)
     *
     * We are therefore choosing to avoid applying the XSLT server-side (we still have to
     * parse the XML in node, but at least it's isolated from our primary server) and
     * to put the XML in a sandboxed iframe. That iframe can't make requests to our server,
     * so we're going to apply the XSLT on the client and then put the HTML in the "srcdoc"
     * element, which is used to populate the iframe without giving the iframe script permissions.
     */
    function renderXmlInSandbox() {
        var $iFrame = $('iframe', that.getContentElt()).addClass('el8Loading');

        var xmlUrl = el8.service.urls.get('getSummaryRawXml', [patientId, summaryId]);
        var xslUrl = el8.service.urls.get('getSummaryXsl', [patientId, summaryId]);

        // waits until both async requests return to do anything (http://api.jquery.com/jQuery.when/)
        $.when( asyncLoadXMLDoc(xmlUrl), asyncLoadXMLDoc(xslUrl) ).done(function(a1, a2) {
            var xml = a1[0]; // format of a1/a2: [ data, statusText, jqXHR ]
            var xsl = a2[0];

            var xsltProcessor = new XSLTProcessor();
            xsltProcessor.importStylesheet(xsl);
            var resultDocument = xsltProcessor.transformToFragment(xml, document); // transformed HTML as a DocumentFragment

            var serializer = new XMLSerializer();
            var htmlStr = serializer.serializeToString(resultDocument); // transformed HTML as String
            $iFrame.attr('srcdoc', htmlStr).removeClass('el8Loading');

            that.adjustPosition();
        });
    }

    // Just returns an AJAX request that can be passed in to the $.when clause
    function asyncLoadXMLDoc(filename) {
        return $.el8_ajax({
            type: 'GET',
            url: filename,
            dataType: 'xml',
            async: true
        });
    }

    function renderImportedList() {
        var importedSections = [];
        var xmlSummary = el8.ptdata.xmlSummaries.getById(summaryId);

        if (xmlSummary.isAllergiesImported()) {
            importedSections.push('Allergies');
        }
        if (xmlSummary.isDemographicsImported()) {
            importedSections.push('Demographics');
        }
        if (xmlSummary.isImmunizationsImported()) {
            importedSections.push('Immunizations');
        }
        if (xmlSummary.isMedicationsImported()) {
            importedSections.push('Medications');
        }
        if (xmlSummary.isProblemsImported()) {
            importedSections.push('Problems');
        }
        if (xmlSummary.isEncountersImported()) {
            importedSections.push('Encounters');
        }

        $('.imported-section-list', that.getContentElt()).html(
            el8.template.appchart.dialog.viewInlineCda.importedSectionList({
                importedSections: importedSections,
                dataFormat: xmlSummary.getDataFormat()
            })
        );
        that.adjustPosition();
    }

    function signFn(doImport) {
        var xmlSummary = el8.ptdata.xmlSummaries.getById(summaryId);

        var behalfUserId = null;
        var $physicianSelect = $(':input[name="physicianUser"]', that.getContentElt());
        if ($physicianSelect.length) {
            behalfUserId = $physicianSelect.val()*1;
        }
        var $signImportBtn = that.getButtonElt().find('.el8ButtonItem button[name="sign-import"]');
        if (doImport) {
            el8.appservice.notifier.notify('Signing off and importing data from patient summary...');
            // going to disable button to prevent double clicking
            $signImportBtn.prop('disabled', true);
        }
        xmlSummary.sign({
            doImport: doImport,
            behalfUserId: behalfUserId,
            successCb: function(updatedSummary, rawData) {
                if (doImport) {
                    el8.appservice.notifier.notify('Data from patient summary imported.');
                }
                $('.import-button-section', that.getContentElt()).replaceWith(
                    el8.template.appchart.dialog.viewInlineCda.buttonSection(updatedSummary.asSoyMap())
                );
                buttonSet.hideButton('sign');
                buttonSet.hideButton('sign-import');
                buttonSet.hideButton('sign-import-qrda');
                $('.select-physician-section', that.getContentElt()).remove();
                renderImportedList();
                if (rawData.changed_sections) {
                    el8.appchart.mainFeeds.chartFileUploader.refreshChangedSections(rawData.changed_sections);
                }
            },
            completeCb: function() {
                $signImportBtn.prop('disabled', false);
                el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();
            }
        });
    }

    return that;

})();
